import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TranslateModule } from '@ngx-translate/core';

import { ButtonsAngularModule } from 'rev-shared/ui/buttons/ButtonsAngular.Module';
import { DirectivesAngularModule } from 'rev-shared/util/directives/DirectivesAngular.Module';
import { FormGroupAngularModule } from 'rev-shared/ui/formGroup/FormGroupAngular.Module';
import { InsightAngularModule } from 'rev-shared/ui/insight/InsightAngular.Module';
import { InsightModule } from 'rev-shared/ui/insight/ngx/Insight.Module';
import { SelectAngularModule } from 'rev-shared/ui/select/SelectAngular.Module';
import { SpinnerAngularModule } from 'rev-shared/ui/spinner/SpinnerAngular.Module';
import { TextInputAngularModule } from 'rev-shared/ui/text-input/TextInputAngular.Module';
import { ValidationAngularModule } from 'rev-shared/ui/validation/ValidationAngular.Module';
import { ValidationModule } from 'rev-shared/util/directives/form/validation/Validation.AngularModule';
import { VideoAccessControlAngularComponent } from './VideoAccessControlAngular.Component';
import { VbUiDatePickerModule } from 'rev-shared/ui/datePicker/VbUiDatePicker.Module';

const components = [VideoAccessControlAngularComponent];

@NgModule({
	declarations: components,
	exports: components,
	imports: [
		CommonModule,
		FormsModule,
		InsightModule,
		InsightAngularModule,
		ButtonsAngularModule,
		TooltipModule,
		DirectivesAngularModule,
		FormGroupAngularModule,
		SpinnerAngularModule,
		TextInputAngularModule,
		TranslateModule,
		ValidationAngularModule,
		ValidationModule,
		SelectAngularModule,
		VbUiDatePickerModule
	]
})
export class SharedVideoSettingsAngularModule { }
